import Vue from 'vue';
 let noHeadSpace =  Vue.directive('no-head-space', {
    bind(el){
    el.addEventListener('input', function(event) {
        const inputValue = event .target.value
        const trimmedValue = inputValue.trimLeft()
        if (inputValue !== trimmedValue) {
            event.target.value = trimmedValue
            event.target.dispatchEvent(new Event('input', {
                bubbles: true
            }))
        }
    })
}
})


 let noTailSpace = Vue.directive('no-tail-space', {
    bind(el, binding, vnode) {
        el.addEventListener('change', function (event) {
            const value = event.target.value;
            const regex = /\s+$/;
            if (regex.test(value)) {
                const newValue = value.replace(regex, '');
                event.target.value = newValue;
                vnode.componentInstance.$emit('input', newValue);
            }
        });
    },
});

 export default {
     noHeadSpace,
     noTailSpace
 }